// src/lib/use-calculator.ts
// Pure payment-plan math — separated from presentation.

import type { CalcResult, ScheduleRow } from "@/types/calculator";
import { useMemo } from "react";

export function useCalculator(
  price: number,
  downPct: number,
  years: number,
  perYear: number,
): CalcResult {
  return useMemo(() => {
    const down = Math.round((price * downPct) / 100);
    const remaining = price - down;
    const totalPeriods = years * perYear;
    const installment = Math.round(remaining / Math.max(1, totalPeriods));
    const monthly = Math.round(remaining / (years * 12));

    // First 6 rows: down payment + 5 monthly instalments.
    const schedule: ScheduleRow[] = [{ index: 0, isDown: true, monthOffset: 0, amount: down, balance: remaining }];
    let balance = remaining;
    for (let i = 1; i <= 5; i++) {
      balance = Math.max(0, balance - monthly);
      schedule.push({ index: i, isDown: false, monthOffset: i, amount: monthly, balance });
    }

    return { down, remaining, installment, monthly, schedule };
  }, [price, downPct, years, perYear]);
}
